// extracted by mini-css-extract-plugin
export default {"signup":"tGi5","form":"_23PU","loginButtonLabel":"_8GgD","social":"tI7-","socialTitle":"GXCn","socialButtons":"pgSU","facebookButton":"jUAf"};